import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFadeInOnScroll } from '../../../hooks/useFadeInOnScroll';
import { Container, EnhancedSectionTitle, SectionSubtitle } from '../../styles/sharedComponents';
import { CTASection, LoopraLogo } from './styles';

const CTA: React.FC = () => {
  const { t } = useTranslation();
  const [ctaRef, ctaVisible] = useFadeInOnScroll<HTMLElement>();

  return (
    <CTASection ref={ctaRef} $isVisible={ctaVisible}>
      <LoopraLogo
        src="/gif/loopra_fly.gif"
        alt="Loopra Flying Bird"
        loading="lazy"
      />
      <Container>
        <EnhancedSectionTitle>{t('cta.title')}</EnhancedSectionTitle>
        <SectionSubtitle style={{ marginBottom: '40px' }}>
          {t('cta.subtitle')}
        </SectionSubtitle>

        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
        </div>
      </Container>
    </CTASection>
  );
};

export default CTA;
